type LegacyDirectoryGlobals = typeof globalThis & {
  getStateDisplayName?: (state: string) => string;
};

/**
 * Older cached Dispensaries bundles used this helper as an unqualified browser
 * global. The current country-aware route no longer needs it, but defining a
 * no-op compatibility version before lazy routes load prevents embedded
 * browsers with a retained old bundle from crashing before they refresh.
 */
export function installLegacyDirectoryCompatibility(): void {
  const globals = globalThis as LegacyDirectoryGlobals;
  globals.getStateDisplayName ??= (state: string) => state;
}
